/**
 * @author ydoni
 * @description 16:9 비율 유지하는 기본 섬네일
 *
 *
 * 2:1 : padding-top: 50%;
 * 1:2 : padding-top: 200%;
 * 4:3: padding-top: 75%;
 * 16:9 : padding-top: 56.25%
 */
import { INSTALLATION_PRINT_PAGE_STYLE } from "pages/reports/view/installation/InstallPrintPageStyled";
import styled from "styled-components";
import { COLORS } from "styles/colors";

const DefaultThumbnail = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  overflow: hidden;
  background-color: ${COLORS.BLACK};
  background-image: linear-gradient(${COLORS.BLACK}, ${COLORS.BLACK}) !important;

  @media print {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    color-adjust: exact;
    min-height: 140px;
    aspect-ratio: 16 / 9;
    height: auto;
    padding-bottom: 0;
  }
  ${INSTALLATION_PRINT_PAGE_STYLE}

  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  > img,
  .video-loss-image,
  .hover-video,
  .icon-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .transcoding-image {
    * {
      color: ${COLORS.WARNING};
    }
  }

  .thumbnail-url {
    display: block;
  }
`;

export default DefaultThumbnail;
